"use client"

import { useState } from "react"
import {
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material"
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline"
import styles from '../../styles/menu/RowActionMenu.module.scss'

const RowActionMenu = ({ menuItems, rowData, isDisabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = async (item) => {
    const result = item.action(rowData)
    if (result != null && typeof result.then === 'function') {
      await result
    }
    handleClose()
  }

  const normalItems = menuItems.filter(item => item.name !== "Delete")
  const deleteItems = menuItems.filter(item => item.name === "Delete")

  return (
    <div className={styles['row-action-container']}>
      <Tooltip title="Options">
        <span>
          <IconButton
            onClick={handleClick}
            size="small"
            disabled={isDisabled}
            className={styles['row-action-trigger']}
          >
            <EllipsisVerticalIcon className="icon" />
          </IconButton>
        </span>
      </Tooltip>

      <Menu
        id="row-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        classes={{
          paper: styles.dropdownPaper,
          list: styles.menuList,
        }}
      >
        {[...normalItems, ...(deleteItems.length ? ["__divider__"] : []), ...deleteItems].map((item, index) => {
          if (item === "__divider__") {
            return (
              <Divider
                key={`divider-${index}`}
                className={styles['row-action-divider']}
              />
            )
          }

          const isDelete = item.name === 'Delete'
          
          // Evaluate disabled - if it's a function, call it with rowData
          const isDisabled = typeof item.disabled === 'function' 
            ? item.disabled(rowData) 
            : item.disabled

          return (
            <MenuItem
              key={index}
              onClick={() => handleMenuItemClick(item)}
              disabled={isDisabled}
              className={`${styles['row-action-item']} ${
                isDisabled ? styles['row-action-item--disabled'] : ''
              } ${isDelete ? styles['row-action-item--delete'] : ''}`}
            >
              <span className={styles['row-action-icon']}>
                {item.icon}
              </span>
              <span className={styles['row-action-text']}>
                {item.name}
              </span>
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}

export default RowActionMenu
